const AccessDeniedIcon = () => {
  return (
    <svg viewBox="0 0 107.143 150">
      <g transform="translate(-972 -590)">
        <path
          d="M222.857,281.429l-14.286,14.286H194.286L180,281.429V210h42.857v28.571l-7.143,7.143,7.143,7.143V260l-7.143,7.143,7.143,7.143Z"
          transform="translate(824.143 444.286)"
          fill="#387dba"
        />
        <path
          d="M193.571,47.143a19.123,19.123,0,0,0-13.214-12.857A179.236,179.236,0,0,0,143.571,30a179.236,179.236,0,0,0-36.786,4.286A19.123,19.123,0,0,0,93.571,47.143,86.794,86.794,0,0,0,90,71.071,86.794,86.794,0,0,0,93.571,95a17.444,17.444,0,0,0,13.214,12.5,154.525,154.525,0,0,0,36.786,4.643,179.236,179.236,0,0,0,36.786-4.286,18.033,18.033,0,0,0,13.214-12.5,86.794,86.794,0,0,0,3.571-23.929A87.407,87.407,0,0,0,193.571,47.143ZM161.429,65.714H125.714a7.164,7.164,0,0,1-7.143-7.143V51.429c0-2.143,11.071-3.571,25-3.571s25,1.429,25,3.571v7.143A7.164,7.164,0,0,1,161.429,65.714Z"
          transform="translate(882 560)"
          fill="#5f97c7"
        />
        <path
          d="M230,260h7.143v67.857H230Z"
          transform="translate(792 412.143)"
          fill="#075da9"
        />
      </g>
    </svg>
  );
};

export default AccessDeniedIcon;
